import { z } from 'zod';

export const searchPlacesSchema = z.object({
  query: z
    .string()
    .min(1, 'Search query is required')
    .max(255, 'Search query must be less than 255 characters'),
});

const operatingHoursSchema = z.object({
  from_hour: z.string().optional(),
  to_hour: z.string().optional(),
  isOpen: z.boolean(),
}).refine(
  (data) => {
    if (data.isOpen) {
      // When open, hours are required and must be valid format
      if (!data.from_hour || !data.to_hour) {
        return false;
      }
      const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
      return timeRegex.test(data.from_hour) && timeRegex.test(data.to_hour);
    }
    // When closed, hours are not required
    return true;
  },
  {
    message: 'Valid opening and closing hours (HH:MM format) are required when open',
  }
);

const weeklyOperatingHoursSchema = z.object({
  Sunday: operatingHoursSchema,
  Monday: operatingHoursSchema,
  Tuesday: operatingHoursSchema,
  Wednesday: operatingHoursSchema,
  Thursday: operatingHoursSchema,
  Friday: operatingHoursSchema,
  Saturday: operatingHoursSchema,
});

export const createVenueFromPlaceSchema = z.object({
  place_id: z.string().min(1, 'Place ID is required'),
  organization_id: z.number().min(1, 'Organization is required'),
  media_url: z.string().url('Invalid media URL'),
  operating_hours: weeklyOperatingHoursSchema.optional(),
});

export type SearchPlacesInput = z.infer<typeof searchPlacesSchema>;
export type CreateVenueFromPlaceInput = z.infer<typeof createVenueFromPlaceSchema>;